/**
 * Alert Fiedset Module is a reusable Module
 */

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Own Components
import { NumberFieldComponent } from "./number-field.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";

/**
 * @deprecated use NumberComponent
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    declarations: [
        NumberFieldComponent
    ],
    exports: [
        NumberFieldComponent
    ]
})

export class NumberFieldModule { }
